<template>
	<div class="main-containter" id="top" v-title data-title="北京和合网链科技有限公司">
		<PHeader :checkId="'业务领域25'"  :activeNames="'业务领域'"></PHeader>
		
		<article>
			<div style="height:150px;width:100%">
				<img src="https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/otherTitle.png" style="height: 100%;width: 100%;">
				<div class="fbannerUpText" style="position: absolute;top: 120px;color: white;font-weight: 600;font-size: 20px;left: calc(50% - 40px);">业务领域</div>
				<div class="fbannerUpText" style="position: absolute;top: 155px;color: white;font-size: 14px;left: calc(50% - 31px);">Business Area</div>
			</div>
			<div style="margin-top:10px;margin-left:3%;">
				<span style="color:#AAAAAA;font-size:14px;">首页 </span>
				<span style="color:#333333;font-size:14px;"> / 业务领域</span>
			</div>
			<div style="font-size: 22px;font-weight: 900;color: #AA1100;margin-left: 3%;margin-top:20px;text-align:center;width:94%;">业务领域</div>
			<div style="color: #AA1100;margin-left: 3%;margin-top: 5px;font-size: 14px;text-align:center;width:94%;">Business Area</div>
			<div style="font-size: 14px;color: #333333;margin-left: 3%;margin-top:10px;text-align:center;width:94%;">北京和合网链科技有限公司专注于健康检测、健康管理与调理服务，以数字化健康管理平台为核心，为企业和个人提供全方位的健康解决方案，在健康管理、健康检测、调理服务等领域积累了丰富的服务经验。我们与医疗机构、社区健康服务中心及各类企事业单位保持良好合作，致力于以科技创新推动智慧健康服务的高质量发展。</div>
			<div style="width:94%;margin-left:3%;margin-bottom:30px;">
				<section>
						<button @click="toDetail(item)" :style="{width:'calc(48% - 0px)','margin-left':(index%2==0)?'0':'2%','margin-right':(index%2!=0)?'0':'2%',height:'55px'}" class="btn btn-green btn-border-o" v-for="(item,index) in tableData" :key="index">
							<div style="float:left;font-size: 13px;font-weight: 500;color: #98273A;margin-top: 20px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
								{{item.title}}
							</div>
							<div style="float:right;font-weight: 500;color: #98273A;font-size: 12px;margin-top: 22px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
								more
							</div>
						</button>
					</section>
			</div>
		</article>
		<Pooter></Pooter>
	</div>
</template>

<script>
	import PHeader from "../../components/p/PHeader.vue"
	import Pooter from "../../components/p/Pooter.vue"
	import {query} from "@/api/service";
	export default {
		name: "Index",
		components: {
			PHeader,
			Pooter
		},
		data() {
			return {
				tableData: [],
				total:0
			}
		},
		mounted() {
			this.list()
		},
		activated(){
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
		},
		methods: {
			toDetail(item,index){
				this.$router.push(
					{
						path:'/phone/businessAreaDetail',
						query:{
							id:item.id
						}
					}
				);
			},
			list() {
				let param = {
					title: '',
					channelId: null,
					page: 1,
					pageSize: 99999,
				}
				query(param).then(data => {
					this.tableData = data.data.list
					this.total = data.data.total
					// console.log("列表",this.tableData)
				}).catch(error => {
					this.$message.error(error)
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.indexAboutUs{
		background: url("https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/phoneBusiness.png") no-repeat;
		height:100%;
		width:100%;
		overflow: hidden;
		background-size:cover;//或者background-size:1
	}
	.main-containter {
		.news{
			background-image: url(../../assets/fImage/homeNewsBg.jpg);
			background-size: cover;
		}
	}
	.main-containter ::v-deep .el-carousel__indicators--horizontal{
		display: none;
	}

	.parentCarousel ::v-deep .el-carousel__container{
		height: 100%;
	}
	body ::v-deep .v-modal{
		display: none;
	}
/* Reset */
 .btn-border-o:before{
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

/* Main Styles */

.btn {
  position: relative;
}

.btn-border-o {
  background-color: transparent;    
  border: 0;
  border-bottom: 1px solid #d0d0d0;
  color: #B8B8B8;
}
.btn-border-o:before {
  content: '';
  border-style: solid;
  position: absolute;
  z-index: 5;
  box-sizing: content-box;
}
.btn-border-o:before {
  width: 0;
  height: 100%;
  border-width: 0 0 1px 0;
  top: -0.5px;
  left: 0;
}
.btn-border-o:hover:before {
  width: 100%;
}
.btn-border-o:hover:after {
  height: 100%;
}
.btn-border-o.btn-green:hover {
  color: #98273A;
}
</style>
